<!--
 * @Author: your name
 * @Date: 2020-08-24 14:48:46
 * @LastEditTime: 2020-09-17 14:32:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jiachi\src\components\HelloWorld.vue
-->
<template>
<div class="naviagator">
    <img src="../assets/img/logo.png" class="logo" @click="$router.push({path:'/'})" />
    <div class="routes">
        <template v-for="(item, index) in $router.options.routes">
            <router-link tag="div" v-if="item.meta.id !== 2" :class="{active:$route.meta.id == index}" :to="{path:item.path}">{{item.name}}</router-link>
            <router-link tag="div" v-else :class="{active:$route.meta.id == index}" :to="{path:'/news/company'}">{{item.name}}</router-link>
        </template>
        <img src="../assets/img/search.png" alt="" @click="show">
    </div>

</div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: {
        msg: String,
    },
    data() {
        return {}
    },
    created() {

    },
    methods: {
        show() {
            this.$parent.show = true
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
.naviagator {
    width: 100%;
    position: fixed;
    top: 0;
    // height: 119px;
    background: rgba(0, 0, 0, 0.3);
    box-shadow: 1px 3px 0px 0px rgba(255, 255, 255, 0.2);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    padding-left: 11%;
    padding-right: 9%;
    z-index: 2;
    box-sizing: border-box;
    min-width: 1200px;

    /deep/.el-dialog__wrapper {
        z-index: 20001;
    }

    .logo {
        height: 55px;
        cursor: pointer;
    }

    .routes {
        display: flex;
        height: 100%;
        align-items: center;
        flex-wrap: wrap;
        min-width: 800px;

        img {
            width: 21px;
            height: 22px;
            margin-left: 30px;
            cursor: pointer;
        }

        div {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            cursor: pointer;
            color: rgba(255, 255, 255, 1);
            line-height: 30px;
            height: 30px;
            width: 90px;
            text-align: center;
            border-radius: 15px;
            background: rgba(4, 154, 218, 0);
            transition: all 0.15s linear;

        }

        div:not(:last-child) {
            margin-right: 28px;
        }

        div.active {
            background: rgba(4, 154, 218, 1);
        }
    }
}
</style>
